import { Box, Typography } from '@mui/material';
import BookingInformationDetail, { BookingInfoHeader } from './BookingInformationDetail';
import { useTranslation } from 'react-i18next';
import TourBillDetailModal from '@/components/TourBillDetailModal';
import { useState } from 'react';

const BookingInfoSection = () => {
  const { t } = useTranslation();

  const [openBillDetailModal, setOpenBillDetailModal] = useState(false);

  return (
    <Box>
      <BookingInfoHeader />
      {/* mobile see detail */}
      <Box sx={{ display: { xs: 'block', md: 'none' } }} onClick={() => setOpenBillDetailModal(true)}>
        <Typography
          variant="body2"
          fontWeight={600}
          color="blue.main"
          sx={{ textDecoration: 'underline', cursor: 'pointer' }}
        >
          {t('common:seeDetailBookedTourInfo')}
        </Typography>
      </Box>
      {/* desktop detail */}
      <Box sx={{ display: { xs: 'none', md: 'block' } }}>
        <BookingInformationDetail key={'booking_info_component'} />
      </Box>

      <TourBillDetailModal
        open={openBillDetailModal}
        onClose={() => setOpenBillDetailModal(false)}
      />

    </Box>
  )
};

export default BookingInfoSection; 